import { fabric } from "fabric";

export const STORAGE_KEY = "deskpadEditorAutoSavedData";

export default class DeskpadPersistent {
  constructor(canvas) {
    this.canvas = canvas;
    this.updateToObject();
  }

  toBase64 = () =>
    btoa(
      JSON.stringify(
        this.canvas.toJSON(["cutW", "cutH", "cutRadius", "settings", "bgColor"])
      )
    );

  loadFromJSON = (json, onLoad, keepSize = false, keepSettings = false) => {
    const { canvas } = this;
    const { settings, cutW, cutH } = canvas;

    canvas.loaded = false;
    canvas.loadFromJSON(json, (e) => {
      if (keepSettings) {
        canvas.settings = { ...settings };
      }
      if (keepSize) {
        canvas.cutW = cutW;
        canvas.cutH = cutH;
        canvas.DPE.cutZone.init();
        canvas.DPE.cutZone.fitContent();
      }
      canvas.DPE.collage?.disableEdit();
      const findById = id => canvas.getObjects().find(o => o.id === id);
      canvas.getObjects().filter(o => o.clipId).forEach(o => {
        const mask = findById(o.clipId)
        o.clipPath = mask;
      })
      onLoad?.();
      canvas.requestRenderAll()
      canvas.fire("canvas:loaded", canvas);
    });
  };
  loadFromBase64 = (base64, ...params) =>
    this.loadFromJSON(JSON.parse(atob(base64)), ...(params ?? {}));
  loadFromStorage = (...params) =>
    this.loadFromBase64(this.getFromStorage(), ...(params ?? {}));

  saveToStorage = () => localStorage.setItem(STORAGE_KEY, this.toBase64());
  getFromStorage = () => localStorage.getItem(STORAGE_KEY);
  clearStorage = () => localStorage.removeItem(STORAGE_KEY);
  isUnsavedDataExists = () => (this.getFromStorage() ? true : false);
  isCanvasEmpty = () =>
    !this.canvas.getObjects().filter((obj) => !obj.excludeFromExport).length;

  //TODO: add placeholder for images to store in JSON
  //TODO: add images
  //FIXME: refactore this :<
  updateToObject = () => {
    fabric.Object.prototype.toObject = ((toObject) =>
      function () {
        const options = {
          id: this.id,
          name: this.name,
          text: this.text,
          dynamicMinWidth: this.dynamicMinWidth,
          fontSize: this.fontSize,
          fontFamily: this.fontFamily,
          selectable: this.selectable,
          _controlsVisibility: this._controlsVisibility,
          lockMovementX: this.lockMovementX,
          lockMovementY: this.lockMovementY,
          lockScalingX: this.lockScalingX,
          lockScalingY: this.lockScalingY,
          lockUniScaling: this.lockUniScaling,
          lockRotation: this.lockRotation,
          objectCaching: this.objectCaching,
          isVector: this.isVector,
          order: this.order,
          //TODO: render border colors depend on propreties
          borderColor: this.borderColor,
          cornerColor: this.cornerColor,
          cornerStrokeColor: this.cornerStrokeColor,
          snap: this.snap,
          evented: this.evented,
          mask: this.mask,
        };
        options.bounds = this.getBoundingRect(true);
        if (this.isSVG) {
          options.isSVG = true;
          options._objects = "undefined";
          options.objects = "undefined";
          options.bounds = this.getBoundingRect(true);
        }
        if (this.type === "image" || this.isSVG) {
          options.hash = this.hash;
          options.src = this.src;
          options.thumb = this.thumb;
          options.size = this.size;
          options.bounds = this.getBoundingRect(true);
        }
        if (this.type === "i-text") {
          options.fontWeight = this.fontWeight;
          options.textAlign = this.textAlign;
          options.fontStyle = this.fontStyle;
          options.bounds = this.getBoundingRect(true);
        }
        if (this.id === "pattern") {
          options.fill = "undefined";
          options.offsetX = this.offsetX;
          options.offsetY = this.offsetY;
          options.patternImageWidth = this.patternImageWidth;
          options.patternImageSource = this.patternImageSource;
        }
        options.clipPath = undefined;
        options.clipId = this.clipId;
        options.absolutePositioned = this.absolutePositioned;
        const object = fabric.util.object.extend(toObject.call(this), options);
        return object;
      })(fabric.Object.prototype.toObject);

    fabric.Image.prototype.toObject = ((toObject) =>
      function () {
        const options = {};
        options.hash = this.hash;
        options.scalable = this.scalable;
        options.thumb = this.thumb;
        options.size = this.size;
        options.bounds = this.getBoundingRect(true);
        options.mask = this.mask;
        if (this.cachedSrc) {
          options.src = this.cachedSrc;
        }
        return fabric.util.object.extend(toObject.call(this), options);
      })(fabric.Image.prototype.toObject);

    fabric.Group.prototype.toObject = ((toObject) =>
      function () {
        const options = {};
        if (this.isSVG) {
          options.isSVG = true;
          options.src = this.src;
          options.objects = undefined;
        }
        return fabric.util.object.extend(toObject.call(this), options);
      })(fabric.Group.prototype.toObject);
  };
}
